import React from "react";
import { useNavigate } from "react-router-dom";

// Compact, chart-only goal-progress grid for the Home dashboard. Consumes the SAME goal-progress
// payload as the Recruiting Dashboard (/recruiting/goals/progress) — no duplicate calculation.
const STATUS = {
  ahead: { c: "#059669", l: "Ahead of pace" },
  behind: { c: "#d97706", l: "Behind pace" },
  critical: { c: "#e11d48", l: "Behind pace" },
  neutral: { c: "hsl(200 100% 28%)", l: "" },
};

function MiniRing({ pct, color }) {
  const R = 26, C = 2 * Math.PI * R;
  const p = Math.max(0, Math.min(100, pct || 0));
  const offset = C * (1 - p / 100);
  return (
    <svg viewBox="0 0 64 64" className="w-16 h-16 -rotate-90">
      <circle cx="32" cy="32" r={R} fill="none" stroke="#e9eef3" strokeWidth="7" />
      <circle cx="32" cy="32" r={R} fill="none" stroke={color} strokeWidth="7" strokeLinecap="round"
        strokeDasharray={C} strokeDashoffset={offset} />
    </svg>
  );
}

export function GoalProgressGrid({ progress }) {
  const navigate = useNavigate();
  const metrics = (progress?.funnel && progress.funnel.length)
    ? progress.funnel
    : Object.values(progress?.metrics || {});
  if (!metrics.length) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="home-goal-progress-grid">
      {metrics.map((m) => {
        const pct = m.pct_ytd ?? m.pct_annual ?? 0;
        const st = STATUS[m.status] || STATUS.neutral;
        return (
          <button key={m.key} onClick={() => navigate("/recruiting")} data-testid={`home-goal-${m.key}`}
            className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md hover:border-slate-300 transition-all text-left">
            <div className="relative shrink-0">
              <MiniRing pct={pct} color={st.c} />
              <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-slate-800">{pct}%</span>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-slate-800 truncate">{m.label}</p>
              <p className="text-xs text-slate-500 tabular-nums">{m.ytd_actual} / {m.ytd_target} <span className="text-slate-400">YTD</span></p>
              {st.l && <p className="text-[11px] font-medium mt-0.5" style={{ color: st.c }}>{m.variance >= 0 ? `+${m.variance}` : m.variance} vs pace · {st.l}</p>}
            </div>
          </button>
        );
      })}
    </div>
  );
}
